// removed by extract-text-webpack-plugin
module.exports = {"main":"DCgb-2CsCFP91KJ1JVyf6","header":"_3M7EBKiMrFI-2cAqt4-UEK","contents":"UvwTsspkS5qWARqvPdY3W","publishSettings":"_355NpfIOxsog01f9dckvtK","footer":"_2FMESZ4FwLCAxyja7kgI5Q"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss
// module id = 294
// module chunks = 0